// extracted by mini-css-extract-plugin
module.exports = {"claim-heading":"ClaimHistoryModal_claim-heading__1fPUU"};